import React from "react";

import { StoreTile } from "@/components/store-tiles/store-tile";

import { UI_CONTEXT, UI_CONTEXTS } from "../../../analytics/constants";
import { useCategory, useCategoryStores } from "../../../hooks/useCategory";
import { CategoryProps } from "../../../interfaces/category-interface";
import { StoreProps } from "../../../interfaces/stores-interface";
import { Offer } from "../../modals/offer";
import useOfferCallbacks from "../../modals/offerCallbacks";
import CardCarousel from "../carousel";
import CardCarouselHeader from "../carousel-header";

export type Props = {
    categorySlug: string;
    initialCategory?: CategoryProps;
    initialCategoryStores?: Array<StoreProps>;
    title?: string;
    ctaNewTab: boolean;
    uiContext: UI_CONTEXT;
};

const PreviewStoresCarousel: React.FC<Props> = ({
    title,
    ctaNewTab,
    uiContext,
    categorySlug,
    initialCategory,
    initialCategoryStores,
}) => {
    const category = useCategory(categorySlug, {
        initialState: initialCategory,
    });

    const stores = useCategoryStores(categorySlug, {
        initialState: initialCategoryStores,
    });

    const {
        isOfferModalsVisible,
        isOfferModalsFading,
        setOfferModalsVisible,
        setOfferModalsFading,
        offerButtonClickHandler,
    } = useOfferCallbacks(stores);

    if (!categorySlug || !category || !stores || stores.length === 0) {
        return null;
    }
    const offerModals = stores.map((store) => {
        return (
            isOfferModalsVisible[store.id] && (
                <Offer
                    store={store}
                    active={isOfferModalsFading[store.id]}
                    setVisibleCallback={setOfferModalsVisible}
                    setFadingCallback={setOfferModalsFading}
                    uiContext={uiContext}
                />
            )
        );
    });
    return (
        <React.Fragment>
            <CardCarouselHeader
                title={title || category.name}
                eventProps={{
                    categoryId: category.id,
                    categoryName: category.name,
                }}
                ctaUrl={category.rootPageUrl}
                ctaNewTab={ctaNewTab}
                uiContext={uiContext || UI_CONTEXTS.HOMEPAGE_TILE}
            />
            <CardCarousel carouselType={"default"}>
                {stores.map((store, position) => (
                    <StoreTile
                        category={category}
                        key={store.id}
                        store={store}
                        analytics={{
                            uiContext: uiContext || UI_CONTEXTS.HOMEPAGE_TILE,
                            eventProps: {
                                categoryId: category.id,
                                categoryName: category.name,
                            },
                        }}
                        position={position}
                        offerButtonClickHandler={offerButtonClickHandler}
                    />
                ))}
            </CardCarousel>
            {offerModals}
        </React.Fragment>
    );
};

export default PreviewStoresCarousel;
